module.exports = __webpack_public_path__ + "static/media/montserrat-latin-800-normal.82f90250.woff";